import { render } from "./MobhotProducts.vue?vue&type=template&id=067f058c&scoped=true"
import script from "./MobhotProducts.vue?vue&type=script&lang=js"
export * from "./MobhotProducts.vue?vue&type=script&lang=js"

import "./MobhotProducts.vue?vue&type=style&index=0&id=067f058c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067f058c"]])

export default __exports__